import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import styles from './navbar.module.css';
import CustomDropdownBar from "../../CustomNavdropdown/CustomDropdownBar";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);
  const timeoutRef = useRef(null);

  const dropdownData = {
    solutions: [
      { title: "Peregrine", path: "/peregrine" },
      { title: "F400", path: "/F400" }
    ],
    platform: [
      { title: "Drone Kits", path: "/axl30" },
      { title: "Rent A Drone", path: "/RentADrone" }
    ],
    components: [
      { title: "Remote Controls", path: "/axlOneView" },
      { title: "GPS", path: "/GPS" },
      { title: "Power Distribution Boards", path: "/PDB" }
    ],
    software: [
      { title: "Viman app", path: "/VimanApp" },
      { title: "Aakash platform", path: "/AakashSoftware" }
    ],
    whoweare: [
      { title: "About", path: "/AboutUs" },
      { title: "Leadership", path: "/Leadership" },
      { title: "Media", path: "/Media" },
      { title: "News", path: "/News" },
      { title: "Careers", path: "/careers" },
      
    ],
    cases: [
      { title: "Blogs", path: "/Blog" }
    ],
    ourpartners: [
      { title: "Resellers", path: "/Resellers" }
    ]
  };

  const navItems = [
    { key: "solutions", label: "Our Drones" },
    { key: "platform", label: "Build Your Drone" },
    { key: "components", label: "Components" },
    { key: "software", label: "Software" },
    { key: "whoweare", label: "Who we are" },
    { key: "cases", label: "Cases" },
    { key: "ourpartners", label: "Our Partners" }
  ];

  const getCurrentActiveNav = () => {
    const currentPath = location.pathname;
    
    for (const [key, items] of Object.entries(dropdownData)) {
      const hasActiveItem = items.some(item => currentPath === item.path);
      if (hasActiveItem) return key;
    }
    return "";
  };

  const getCurrentActiveSubItem = () => {
    const currentPath = location.pathname;
    
    for (const items of Object.values(dropdownData)) {
      const activeItem = items.find(item => currentPath === item.path);
      if (activeItem) return "" //activeItem.path;
    }
    return "";
  };

  // Auto-close hamburger menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
    setActiveDropdown("");
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setIsMenuOpen(false);
        setActiveDropdown("");
      }
    };

    // Close menu when pressing Escape key
    const handleEscapeKey = (e) => {
      if (e.key === 'Escape') {
        setIsMenuOpen(false);
        setActiveDropdown("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleNavigation = (path) => {
    setActiveDropdown("");
    setIsMenuOpen(false);
    navigate(path);
  };

  // Enhanced function to close menu (useful for any direct navigation)
  const closeMenuAndNavigate = (path) => {
    setIsMenuOpen(false);
    setActiveDropdown("");
    navigate(path);
  };

  const showDropdown = (key) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setActiveDropdown(key);
  };

  const hideDropdown = () => {
    timeoutRef.current = setTimeout(() => {
      setActiveDropdown("");
    }, 100);
  };

  const keepDropdown = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  return (
    <nav className={styles.navbar} ref={navRef}>
      <div className={styles.logo}>
        <Link 
          to="/" 
          onClick={() => setIsMenuOpen(false)} // Close menu when logo is clicked
        >
          <img src="../../../Assets/Images/axldroneLogo.svg" alt="AxlDrone" />
        </Link>
      </div>

      <button 
        className={styles.menuBtn} 
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className={`${styles.nav} ${isMenuOpen ? styles.navOpen : ""}`}>
        {isMenuOpen && (
          <li className={styles.closeBtn}>
            <button onClick={() => setIsMenuOpen(false)} aria-label="Close menu">×</button>
          </li>
        )}

        {navItems.map(({ key, label }) => (
          <li
            key={key}
            className={styles.navItem}
            onMouseEnter={() => showDropdown(key)}
            onMouseLeave={hideDropdown}
          >
            <span className={`${styles.navLink} ${getCurrentActiveNav() === key ? styles.active : ""}`}>
              {label}
            </span>

            {activeDropdown === key && (
              <div 
                className={styles.dropdown}
                onMouseEnter={keepDropdown}
                onMouseLeave={hideDropdown}
              >
                <CustomDropdownBar
                  dropdownData={dropdownData[key]}
                  handleNavigation={handleNavigation}
                  currentActiveSubItem={getCurrentActiveSubItem()}
                />
              </div>
            )}
          </li>
        ))}

        <li className={styles.navItem}>
          <button
            className={styles.ctaBtn}
            onClick={() => closeMenuAndNavigate('/getintouch')}
          >
            Let's talk
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;